/* eslint-disable complexity */
import {
  FILTER_SUBCATEGORY,
  FILTER_CATEGORY,
  FILTER_SORTBY,
  FILTER_MINPRICE,
  FILTER_MAXPRICE,
  FILTER_ALL,
  FILTER_TAG,
} from '../config/setup/setup';
import { VIP } from '../config/text/text';
import { isSSR } from './ssr';

export const getNavigationCategoriesWithFaceted = (facetedNavigation) => {
  if (
    !facetedNavigation ||
    !facetedNavigation.navigations ||
    !facetedNavigation.navigations.length
  )
    return [];

  return facetedNavigation.navigations.map((item) =>
    Object.assign(
      {},
      {
        isActive: item.isActive,
        name: item.linkText,
        url: item.url,
        value: item.shortName || FILTER_ALL,
      },
    ),
  );
};

export const generateDynamicMarks = (minPrice = 0, maxPrice = 1_000) => {
  const marks = [];

  const startPrice = (() => {
    if (minPrice <= 0) return 0;
    if (minPrice <= 100) {
      return Math.floor(minPrice / 5) * 5;
    } else {
      return Math.floor(minPrice / 10) * 10;
    }
  })();

  const endPrice = (() => {
    if (maxPrice <= 100) {
      return Math.ceil(maxPrice / 5) * 5;
    } else {
      return Math.ceil(maxPrice / 10) * 10;
    }
  })();

  let currentPrice = startPrice;

  while (currentPrice <= endPrice) {
    marks.push({ name: currentPrice, value: currentPrice });

    if (currentPrice < 100) {
      currentPrice += 5;
    } else if (currentPrice < 500) {
      currentPrice += 10;
    } else {
      currentPrice += 50;
    }
  }

  return marks;
};
// for rounding
export const snapToStepMax = (value) => {
  if (value <= 100) {
    return Math.ceil(value / 5) * 5;
  } else if (value <= 500) {
    return Math.ceil(value / 10) * 10;
  } else {
    return Math.ceil(value / 50) * 50;
  }
};

export const assignSliderValueNewFilter = (value, options, defaultValue) => {
  if (!value) return defaultValue;
  const index = options.findIndex((entry) => Number(entry.value) === value);
  if (index > -1) {
    return index;
  } else {
    return defaultValue;
  }
};

export const assignSliderValue = (value, options, defaultValue) => {
  const index = options.findIndex((entry) => entry.value === value);
  if (index > -1) {
    return index;
  } else {
    return defaultValue;
  }
};

export const getGiftUrlWithFilterQuery = ({
  categories,
  sortBy,
  sliderValues,
  filterPrice,
  giftsFor,
  searchTags,
}) => {
  const query = new URLSearchParams(window.location.search);

  if (categories) {
    query.delete(FILTER_CATEGORY);
    categories.forEach((category) => {
      query.append(FILTER_CATEGORY, category);
    });
  }

  if (giftsFor) {
    query.delete('giftFor');
    query.set('giftFor', giftsFor);
  }

  if (searchTags) {
    query.delete('searchTag');
    searchTags.forEach((tag) => {
      query.append(FILTER_TAG, tag);
    });
  }

  if (giftsFor === '') query.delete('giftFor');

  if (sortBy === '-1') {
    query.delete(FILTER_SORTBY);
  } else {
    query.set(FILTER_SORTBY, sortBy);
  }

  const [minIndex, maxIndex] = sliderValues;
  if (minIndex > 0) {
    query.set(FILTER_MINPRICE, filterPrice[minIndex].value);
  } else {
    query.delete(FILTER_MINPRICE);
  }
  if (maxIndex < filterPrice.length - 1) {
    query.set(FILTER_MAXPRICE, filterPrice[maxIndex].value);
  } else {
    query.delete(FILTER_MAXPRICE);
  }

  const search = query.toString();

  return `${window.location.pathname}${search.length ? '?' + search : ''}`;
};

export const getUrlWithFilterQuery = ({
  details,
  filterPrice,
  categories,
  subCat,
  sortBy,
  sliderValues,
  vipSearchFilter,
}) => {
  const query = new URLSearchParams(window.location.search);

  if (vipSearchFilter) {
    query.set(VIP.toLowerCase(), vipSearchFilter);
  } else {
    query.delete(VIP.toLowerCase());
  }

  if (categories) {
    query.delete(FILTER_CATEGORY);
    categories.forEach((category) => {
      query.append(FILTER_CATEGORY, category);
    });
  }

  if (
    // if the page has a subcat, we can't just delete the filter subcat else it will default to the subcat of the page
    (subCat === FILTER_ALL && !details.subCategory) ||
    // delete when the chosen subcat is the page subcat
    (subCat !== FILTER_ALL && subCat === details.subCategory)
  ) {
    query.delete(FILTER_SUBCATEGORY);
  } else {
    query.set(FILTER_SUBCATEGORY, subCat);
  }

  if (sortBy === '-1') {
    query.delete(FILTER_SORTBY);
  } else {
    query.set(FILTER_SORTBY, sortBy);
  }

  const [minIndex, maxIndex] = sliderValues;
  if (minIndex > 0) {
    query.set(FILTER_MINPRICE, filterPrice[minIndex].value);
  } else {
    query.delete(FILTER_MINPRICE);
  }
  if (maxIndex < filterPrice.length - 1) {
    query.set(FILTER_MAXPRICE, filterPrice[maxIndex].value);
  } else {
    query.delete(FILTER_MAXPRICE);
  }

  const search = query.toString();

  return `${window.location.pathname}${search.length ? '?' + search : ''}`;
};

export const getUrlWithNewFilters = (
  filterParameters,
  vipSearchFilter,
  filterPrice = [],
  isSubCat = false,
) => {
  const query = new URLSearchParams(window.location.search);

  // Handle VIP filter
  if (vipSearchFilter) {
    query.set(VIP.toLowerCase(), vipSearchFilter);
  } else {
    query.delete(VIP.toLowerCase());
  }

  // Preserve search query if it exists
  const preservedSearchQuery = query.get('q');

  // Destructure filter parameters
  const {
    sliderValues: sliderValuesFromParameters,
    sortBy,
    subCat,
    vip: _,
    ...otherParameters
  } = filterParameters;
  const finalSliderValues = sliderValuesFromParameters;
  if (
    sortBy !== undefined &&
    sortBy !== null &&
    sortBy !== '' &&
    sortBy !== '-1'
  ) {
    query.set(FILTER_SORTBY, sortBy);
  } else {
    query.delete(FILTER_SORTBY);
  }

  if (
    !isSubCat &&
    subCat !== undefined &&
    subCat !== null &&
    subCat !== '' &&
    subCat !== FILTER_ALL
  ) {
    query.set(FILTER_SUBCATEGORY, subCat);
  } else {
    query.delete(FILTER_SUBCATEGORY);
  }

  // Process price filters
  let newMinPrice = null;
  let newMaxPrice = null;

  if (
    finalSliderValues &&
    Array.isArray(finalSliderValues) &&
    filterPrice.length > 0
  ) {
    const [minIndex, maxIndex] = finalSliderValues;

    if (minIndex > 0 && filterPrice[minIndex]) {
      newMinPrice = Number(filterPrice[minIndex].value);
    }

    if (maxIndex < filterPrice.length - 1 && filterPrice[maxIndex]) {
      newMaxPrice = Number(filterPrice[maxIndex].value);
    }
  }

  // Update min price
  if (newMinPrice !== null && !isNaN(newMinPrice)) {
    query.set(FILTER_MINPRICE, newMinPrice.toString());
  } else {
    query.delete(FILTER_MINPRICE);
  }

  // Update max price
  if (newMaxPrice !== null && !isNaN(newMaxPrice)) {
    query.set(FILTER_MAXPRICE, newMaxPrice.toString());
  } else {
    query.delete(FILTER_MAXPRICE);
  }

  // Define special parameters that should be preserved
  const specialParameters = [
    'q',
    'vip',
    FILTER_MINPRICE,
    FILTER_MAXPRICE,
    FILTER_SORTBY,
    FILTER_SUBCATEGORY,
  ];

  // First, preserve all existing f_* parameters
  const preservedFilters = {};
  query.forEach((value, key) => {
    if (key.startsWith('f_')) {
      preservedFilters[key] = value;
    }
  });

  Array.from(query.keys()).forEach((key) => {
    if (!specialParameters.includes(key) && !(key in otherParameters)) {
      query.delete(key);
    }
  });
  Object.entries(otherParameters).forEach(([key, value]) => {
    if (
      value !== undefined &&
      value !== null &&
      value !== '' &&
      value !== false
    ) {
      if (Array.isArray(value)) {
        query.set(key, value.map((item) => encodeURIComponent(item)).join(','));
      } else {
        query.set(key, encodeURIComponent(value.toString()));
      }
    } else {
      query.delete(key);
    }
  });
  const existingMaxPrice = query.get(FILTER_MAXPRICE);
  if (
    existingMaxPrice &&
    newMaxPrice !== null &&
    Number(existingMaxPrice) !== newMaxPrice
  ) {
    query.set(FILTER_MAXPRICE, newMaxPrice.toString());
  } else if (existingMaxPrice && newMaxPrice === null) {
    query.delete(FILTER_MAXPRICE);
  }
  const existingMinPrice = query.get(FILTER_MINPRICE);
  if (
    existingMinPrice &&
    newMinPrice !== null &&
    Number(existingMinPrice) !== newMinPrice
  ) {
    query.set(FILTER_MINPRICE, newMinPrice.toString());
  } else if (existingMinPrice && newMinPrice === null) {
    query.delete(FILTER_MINPRICE);
  }
  if (preservedSearchQuery) {
    query.set('q', preservedSearchQuery);
  }

  const search = query.toString();

  return `${window.location.pathname}${search.length ? '?' + search : ''}`;
};

export const isFiltered = () => {
  const query = new URLSearchParams(isSSR() ? '' : window.location.search);

  const filters = [
    FILTER_CATEGORY,
    FILTER_SUBCATEGORY,
    FILTER_SORTBY,
    FILTER_MINPRICE,
    FILTER_MAXPRICE,
  ];

  for (const filter of filters) {
    if (query.has(filter)) {
      const value = query.get(filter);
      // popularity is the default so we can consider it as not a filter.
      if (filter === FILTER_SORTBY && value === 'popularity') {
        continue;
      }

      return true;
    }
  }

  return false;
};

export const isNewFiltered = () => {
  const query = new URLSearchParams(isSSR() ? '' : window.location.search);

  const filters = [FILTER_SORTBY, FILTER_MINPRICE, FILTER_MAXPRICE];

  for (const filter of filters) {
    if (query.has(filter)) {
      const value = query.get(filter);
      // popularity is the default so we can consider it as not a filter.
      if (filter === FILTER_SORTBY && value === 'popularity') {
        continue;
      }

      return true;
    }
  }
  // Check for any key containing 'uFilter'
  for (const [key] of query.entries()) {
    if (key.includes('uFilter')) {
      return true;
    }
  }

  return false;
};
